
































































































































































import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel, DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import DeleteDialog from '@/components/DeleteDialog.vue'
import {
  COMPANY_FETCH_COMPANY_STRUCTURE, DELETE_DOCUMENT_DATA, EDIT_DOCUMENT_DATA, FETCH_DOCUMENT_BY_ID,
  FETCH_DOCUMENT_GROUP,
  FETCH_DOCUMENT_LIST,
  SAVE_DOCUMENT_DATA
} from '@/store/action-types'
import { Employee } from '@/model/companyStructure/Employee'
import { COMPANY_GET_BASIC_COMPANY_STRUCTURE, GET_CURRENT_USER_ID } from '@/store/getter-types'
import { SaveDocumentAttachmentRequest } from '@/types/payload'
import { DocumentGroupListResponse, ResponseBase, SaveDocumentResponse } from '@/types/service-response'
import { Document } from '@/model/documents/Document'
import moment from 'moment'
import { DocumentGroup } from '@/model/documents/DocumentGroup'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface EventFile extends Event {
  target: HTMLInputElement & EventTarget
}

interface ComponentData {
  tableHeight: string
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  loading: boolean
  saveLoading: boolean
  downloadLoading: boolean
  showDeleteDialog: boolean
  documentIndex: number
  selectedDocument: Document | null
  isEdit: boolean
  rules: Function[]
  fileRules: Function[]

  documentList: Document[]

  gruppeList: DocumentGroup[]
  employeeList: Employee[]

  isFilterGruppe: boolean
  filterGruppe: number | null
  isFilterAutor: boolean
  filterAutor: number | null
  allgemeine: string | null
  isAlleDokumente: boolean

  gruppe: number | null
  code: string | null
  bezeichnung: string | null
  datei: string | null
  selectedAuthor: number | null
  erstellungsdatum: string | null
  komentar: any | null

  type: string | null
  document: string | null

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'CommissionDocuments',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    DeleteDialog
  },

  props: {
    documentType: String,
    recordId: Number,
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      loading: false,
      saveLoading: false,
      downloadLoading: false,
      showDeleteDialog: false,
      documentIndex: 0,
      selectedDocument: null,
      isEdit: false,
      rules: [(value: any): boolean | string => !!value || ''],
      // @ts-ignore
      fileRules: [(): boolean | string => !!this.document],

      documentList: [],

      gruppeList: [],
      employeeList: [],

      isFilterGruppe: false,
      filterGruppe: null,
      isFilterAutor: false,
      filterAutor: null,
      allgemeine: null,
      isAlleDokumente: false,

      gruppe: null,
      code: null,
      bezeichnung: null,
      datei: null,
      selectedAuthor: null,
      erstellungsdatum: null,
      komentar: null,

      type: null,
      document: null,

      keyActions: []
    }
  },

  watch: {
    commissionId (newVal: number): void {
      if(newVal) {
        this.fetchDocumentList()
      }
    },

    selectedDocument (newVal: any | null): void {
      const form: any = this.$refs['form']
      form.resetValidation()
      if(newVal) {
        this.isEdit = false
        this.setData()
      } else {
        this.setData()
      }
    },
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    isDocumentBeforeDisabled(): boolean {
      return this.documentIndex === 0 || this.filteredDocumentList.length === 0
    },

    isDocumentAfterDisabled(): boolean {
      return this.documentIndex === this.filteredDocumentList.length -1 || this.filteredDocumentList.length === 0
    },

    filteredDocumentList (): Document[] {
      let filteredList: Document[] = this.documentList
      if(this.isFilterGruppe && this.filterGruppe) {
        filteredList = filteredList.filter((item: Document) => item.dokumentGruppeId === this.filterGruppe!)
      }

      if(this.isFilterAutor && this.filterAutor) {
        filteredList = filteredList.filter((item: Document) => item.autorId === this.filterAutor!)
      }

      return filteredList
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return !(!this.selectedDocument || this.isEdit)
      } else if(action instanceof Delete) {
        return !(!this.selectedDocument || this.isEdit)
      } else {
        return false
      }
    },

    formatDate(item: string): string {
      return item && moment(item).isValid() ? moment(item).format('DD.MM.YYYY') : ''
    },

    onFilterChange (): void {
      this.documentIndex = 0
      this.selectedDocument = this.filteredDocumentList[this.documentIndex] ?  this.filteredDocumentList[this.documentIndex] : null
      this.setData()
    },

    onAddDocumentClick (): void {
      this.selectedAuthor = this.currentUserId
      this.erstellungsdatum = moment().format('DD.MM.YYYY')
      this.selectedDocument = null
      this.isEdit = true

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 100)
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddDocumentClick()
    },

    onEditDocumentClick (): void {
      this.isEdit = true

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 100)
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditDocumentClick()
    },

    onDeleteDocumentClick (): void {
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteDocumentClick()
    },

    onDocumentBeforeClick (): void {
      this.documentIndex -= 1
      this.selectedDocument = this.filteredDocumentList[this.documentIndex]
    },

    onDocumentAfterClick (): void {
      this.documentIndex += 1
      this.selectedDocument = this.filteredDocumentList[this.documentIndex]
    },

    /*onUploadClick (): void {
      // @ts-ignore
      this.$refs.documentInput.click()
    },*/

    onDocumentChange (e: EventFile): void {
      if (e && e.target.files) {
        const file: File | undefined = e.target.files[0]

        if (file) {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = (e: any) => {
            if (e.target && e.target.result) {
              //let type: string = e.target.result.split('/')[1].split(';')[0]
              let document = e.target.result.split(',')[1]

              if(file.type && document) {
                this.datei = file.name
                this.type = file.type
                this.document = document
              }

              // @ts-ignore
              this.$refs.documentInput.value = null
            }
          }
        }
      }
    },

    onDownloadClick (): void {
      this.fetchDocumentById()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.deleteDocumentData()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        this.saveDocumentData()
      }
    },

    onCancelClick (): void {
      this.isEdit = false
      if(!this.selectedDocument && this.documentList.length > 0) {
        this.documentIndex = 0
        this.selectedDocument = this.documentList[this.documentIndex]
      }
      this.setData()
    },

    onGetFileClick (): void {
      // @ts-ignore
      this.$refs.documentInput.click()
    },

    onRowClick (rowData: any): void {
      this.selectedDocument = rowData.data
      this.documentIndex = this.documentList.indexOf(this.selectedDocument!)
    },

    async saveDocumentData (): Promise<void> {
      const payload: SaveDocumentAttachmentRequest = {
        Tabelle: this.documentType,
        Datensatz: this.recordId,
        DokumentID: this.selectedDocument ? this.selectedDocument.id : null,
        Gruppe: this.gruppe!,
        Code: this.code,
        Bezeichnung: this.bezeichnung,
        Dateiname: this.datei,
        Autor: this.selectedAuthor!,
        Kommentar: this.komentar,
        File: this.document!,
        FileExtension: this.type!
      }

      if(payload.DokumentID) {
        try {
          this.saveLoading = true
          await this.$store.dispatch(EDIT_DOCUMENT_DATA, payload)
          this.fetchDocumentList(payload.DokumentID)
        } catch {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        } finally {
          this.saveLoading = false
        }
      } else {
        try {
          this.saveLoading = true
          const response: SaveDocumentResponse = await this.$store.dispatch(SAVE_DOCUMENT_DATA, payload)
          if (!response.IsError) {
            this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            this.isEdit = false
            this.type = null
            this.document = null
            this.fetchDocumentList(response.DokumentId)
          } else {
            this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        } finally {
          this.saveLoading = false
        }
      }
    },

    async deleteDocumentData (): Promise<void> {
      try {
        const response: ResponseBase = await this.$store.dispatch(DELETE_DOCUMENT_DATA, this.selectedDocument!.id)
        if(!response.IsError) {
          this.showDeleteDialog = false
          this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchDocumentList()
        } else {
          this.onDeleteDialogClose()
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
      this.employeeList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList
    },

    async fetchDocumentGroupList (): Promise<void> {
      try {
        const response: DocumentGroupListResponse = await this.$store.dispatch(FETCH_DOCUMENT_GROUP)
        if(!response.IsError && response.Data && response.Data.DokumentenGruppen) {
          this.gruppeList = DocumentGroup.createListFromResponse(response.Data.DokumentenGruppen)
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {

      }
    },

    async fetchDocumentList (documentId?: number | null): Promise<void> {
      const payload: any = {
        herkunft: this.documentType,
        recordid: this.recordId
      }
      try {
        const response: any = await this.$store.dispatch(FETCH_DOCUMENT_LIST, payload)
        this.documentList = response
        if(documentId) {
          const foundDocument: Document | undefined = this.filteredDocumentList.find((item: Document) => item.id === documentId)
          if(foundDocument) {
            this.selectedDocument = foundDocument
            this.documentIndex = this.filteredDocumentList.indexOf(this.selectedDocument)
          } else {
            this.documentIndex = 0
            this.selectedDocument = this.filteredDocumentList[this.documentIndex] ?  this.filteredDocumentList[this.documentIndex] : null
          }
        } else {
          this.documentIndex = 0
          this.selectedDocument = this.filteredDocumentList[this.documentIndex] ?  this.filteredDocumentList[this.documentIndex] : null
        }
        this.setData()
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {

      }
    },

    async fetchDocumentById (): Promise<void> {
      try {
        this.downloadLoading = true
        const response: any = await this.$store.dispatch(FETCH_DOCUMENT_BY_ID, this.selectedDocument!.id)
        this.downloadLoading = false
        let fileData = new Blob([response.data], { type: response.headers['content-disposition'] })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(fileData)
        let filename = response.headers['content-disposition'].split(';')[1].split('filename')[1].split('=')[1].trim()
        link.download = filename
        link.click()
      } catch {
        this.downloadLoading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    setData (): void {
      this.gruppe = this.selectedDocument ? this.selectedDocument.dokumentGruppeId : null
      this.code = this.selectedDocument ? this.selectedDocument.dokumentenCode : null
      this.bezeichnung = this.selectedDocument ? this.selectedDocument.dokumentenBezeichnung : null
      this.datei = this.selectedDocument ? this.selectedDocument.dokumentenDatei : null
      this.selectedAuthor = this.selectedDocument ? this.selectedDocument.autorId : this.isEdit ? this.currentUserId : null
      this.erstellungsdatum = this.selectedDocument && this.selectedDocument.erstelltAm ? moment(this.selectedDocument.erstelltAm).format('DD.MM.YYYY') : this.isEdit ?  moment().format('DD.MM.YYYY') : null
      this.komentar = this.selectedDocument ? this.selectedDocument.kommentar : null

      if(this.documentList.length > 0 && this.selectedDocument) {
        //@ts-ignore
        setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.selectedDocument.id])}, 100)
      } else {
        //@ts-ignore
        setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)
      }
    },

    onResize (): void {
      if(this.$refs.formSection && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.formSection as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - ${this.documentType && this.documentType === 'Mitarbeiter' ? '264px' : '232px'} - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    setTimeout(() => { this.onResize() }, 0)
    this.fetchData()
    this.fetchDocumentGroupList()
    this.fetchDocumentList()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
